import { render } from "./PasswordResetForm.vue?vue&type=template&id=16985e70"
import script from "./PasswordResetForm.vue?vue&type=script&lang=js"
export * from "./PasswordResetForm.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/modules/auth/components/PasswordResetForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "16985e70"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('16985e70', __exports__)) {
    api.reload('16985e70', __exports__)
  }
  
  module.hot.accept("./PasswordResetForm.vue?vue&type=template&id=16985e70", () => {
    api.rerender('16985e70', render)
  })

}


export default __exports__